import React, { useContext, useMemo } from 'react';
import { ISearchResult } from './ICustomerService';
import NoSearchResult from './NoSearchResult';
import SearchResult from './SearchResult';
import { useTranslation } from 'react-i18next';
import { en, fr } from './i18n';
import { CustomerServiceContext } from './CustomerServiceContext';

export interface CustomerServiceSearchProps {
    results: ISearchResult[];
}

const CustomerServiceSearch = ({ results }: CustomerServiceSearchProps) => {
    const { i18n, t } = useTranslation('customer-service');
    i18n.addResourceBundle('en', 'customer-service', en, true, true);
    i18n.addResourceBundle('fr', 'customer-service', fr, true, true);

    const { searchTerm } = useContext(CustomerServiceContext);

    return (
        <div className="customer-service-faq__search-results">
            <h3 className="customer-service-faq__search-results__results-count">
                {t('showingResults', { count: results.length, searchTerm })}
            </h3>

            {results.length > 0 && <SearchResult results={results} />}

            {results.length === 0 && <NoSearchResult searchTerm={searchTerm} />}
        </div>
    );
};

export default CustomerServiceSearch;
